export const MACRO_INSIGHTS_FROM_DATE = '2005-01-01';
